import React, { lazy } from "react";
import { Route } from "react-router-dom";

// Lazy load protected pages
const Resume = lazy(() => import("../pages/Resume/Resume"));
const Jobs = lazy(() => import("@/pages/Opportunities/features/Jobs/Jobs"));
const JobDetails = lazy(() =>
  import("@/pages/Opportunities/features/JobDetails/JobDetails")
);
const Feedback = lazy(() => import("@/pages/Feedback/Feedback"));
const Discussions = lazy(() => import("@/pages/Discussions/Discussions"));
const Updates = lazy(() => import("@/pages/Updates/Updates"));
const CourseDetails = lazy(() => import("@/pages/CourseDetails"));
const CheatSheets = lazy(() => import("@/pages/Courses/Cheatsheets/CheatSheets"));
const CheatSheetDetail = lazy(() => import("@/pages/Courses/Cheatsheets/CheatsheetDetails/CheatSheetDetail"));
const MCQTestInstructions = lazy(() => import("@/pages/Courses/MCQs/MCQTest/MCQTestInstructions"));
const MCQTest = lazy(() => import("@/pages/Courses/MCQs/MCQTest/MCQTest"));
const MockInterview = lazy(() => import("@/pages/MockInterview/MockInterview"));
const Profile = lazy(() => import("@/pages/Profile/Profile"));
const CodingPlayground = lazy(() =>
  import("@/pages/CodingPlayground/CodingPlayground")
);
const Courses = lazy(() => import("@/pages/Courses"));
const Mcqs = lazy(() => import("@/pages/Courses/MCQs/Mcqs"));
const Projects = lazy(() => import("@/pages/Courses/Projects/Projects"));
const ProjectDetails = lazy(() => import("@/pages/Courses/Projects/ProjectDetails/ProjectDetails"));
const MockTests = lazy(() => import("@/pages/MockTests"));
const Companies = lazy(() =>
  import("@/pages/Opportunities/features/Companies/Companies")
);
const CompanyDetails = lazy(() =>
  import("@/pages/Opportunities/features/CompaniesProfile/CompaniesProfile")
);

export const ProtectedRoutes = (
  <>
    <Route path="/resume" element={<Resume />} />
    <Route path="/jobs" element={<Jobs />} />
    <Route path="/jobs/:id" element={<JobDetails />} />
    <Route path="/feedback" element={<Feedback />} />
    <Route path="/discussions" element={<Discussions />} />
    <Route path="/updates" element={<Updates />} />
    <Route path="/saved-jobs" element={<Jobs />} />
    <Route path="/courses/:courseId" element={<CourseDetails />} />
    <Route path="/cheat-sheets" element={<CheatSheets />} />
    <Route path="/cheat-sheets/:id" element={<CheatSheetDetail />} />
    <Route path="/mock-interview/:id" element={<MockInterview />} />
    <Route path="/profile" element={<Profile />} />
    <Route path="/mcq-test/instructions" element={<MCQTestInstructions />} />
    <Route path="/mcq-test/:testId" element={<MCQTest />} />
    <Route path="/coding-playground" element={<CodingPlayground />} />
    <Route path="/courses" element={<Courses />} />
    <Route path="/mcqs" element={<Mcqs />} />
    <Route path="/projects" element={<Projects />} />
    <Route path="/projects/:projectId" element={<ProjectDetails />} />
    <Route path="/mock-tests" element={<MockTests />} />
    <Route path="/companies" element={<Companies />} />
    <Route path="/companies/:companyName" element={<CompanyDetails />} />
  </>
);
